export default {
    loaded: "popups.loaded",
    hide: "popups.hide"
}